// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_cartbob_ui_styles" + "." + "da77ed7f" + ".chunk.css";
};